import Vue from 'vue'
import PcNavigationBar from '@/components/pc/navigation-bar.vue'
import PcFooter from '@/components/pc/footer.vue'
Vue.component('PcNavigationBar',PcNavigationBar)
Vue.component('PcFooter',PcFooter)